/** Keep keyboard focus with the Offers that the header's Join control reveals. */
export function scrollToCoverPageOffers(
  section: HTMLElement,
  focusOffer: boolean
) {
  const action = focusOffer
    ? section.querySelector<HTMLElement>(
        ".CoverPageOfferButton:not(:disabled):not([disabled]):not([data-disabled]):not([aria-disabled='true'])"
      )
    : null

  if (action) {
    // Focus synchronously so the next Tab starts here, even during the scroll.
    action.focus({ preventScroll: true })
    action.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest"
    })
  } else {
    section.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
